/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1LockIcon20Solid = forwardRef('People1LockIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 10.335A4.167 4.167 0 1 0 10 2a4.167 4.167 0 0 0 0 8.335Z" }),
        React.createElement("path", { d: "M11.25 13.75c0-.6.125-1.172.35-1.69A19.242 19.242 0 0 0 10 12c-2.362 0-6.887.29-7.827 4.369C1.97 17.252 2.735 18 3.641 18H10v-2a2 2 0 0 1 1.25-1.855v-.395Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 15.058V13.75a2.5 2.5 0 0 1 5 0v1.308a1.4 1.4 0 0 1 1 1.342v2.2a1.4 1.4 0 0 1-1.4 1.4h-4.2a1.4 1.4 0 0 1-1.4-1.4v-2.2a1.4 1.4 0 0 1 1-1.342ZM16.5 15h-2v-1.25a1 1 0 1 1 2 0V15Z" })));
});
